import { ItemZoneContextType } from '@context/ItemZoneContext'
import { ReactMouseEvent, Textures } from '@types'

export default function handleCopy(
  ctx: ItemZoneContextType,
  property: Textures[number],
  e: ReactMouseEvent,
) {
  e.preventDefault()
  e.stopPropagation()
  ctx.setCopiedTexture(property)
  ctx.setCopiedIconId(property.zoneName)
  const newPasteIcons = { ...ctx.pasteIcons }
  Object.keys(newPasteIcons).forEach((zoneId) => {
    newPasteIcons[zoneId] = zoneId === property.zoneName ? 'cantPaste' : 'canPaste'
  })
  ctx.setPasteIcons(newPasteIcons)
  return
}
